export default __webpack_public_path__ + "static/media/North Cleave of the Black Tortoise.e051bdaa.jpg";